var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-media-info"},[_c('div',{staticClass:"mall-media-info-hd"},[(_vm.pic)?_c('img',{attrs:{"src":_vm._f("replaceUrlProtocol")(_vm.pic)}}):_vm._e()]),_c('div',{staticClass:"mall-media-info-bd"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }